module.exports = __webpack_public_path__ + "img/fondation-mathieu-froment-savoie.0a210a06.webp";